import React from 'react';

const InfoFullIcon = () => (
  <svg
    width="18px"
    height="17px"
    viewBox="0 0 18 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="M&amp;I-Sandbox" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M9,0 C10.1458391,0 11.2233022,0.218096777 12.2324219,0.654296875 C13.2415415,1.09049697 14.1236941,1.68619414 14.8789062,2.44140625 C15.6341184,3.19661836 16.2330707,4.08202617 16.6757812,5.09765625 C17.1184918,6.11328633 17.3398438,7.19400469 17.3398438,8.33984375 C17.3398438,9.48568281 17.1184918,10.563146 16.6757812,11.5722656 C16.2330707,12.5813853 15.6341184,13.4635379 14.8789062,14.21875 C14.1236941,14.9739621 13.2415415,15.5696593 12.2324219,16.0058594 C11.2233022,16.4420595 10.1458391,16.6601562 9,16.6601562 C7.85416094,16.6601562 6.77669775,16.4420595 5.76757812,16.0058594 C4.7584585,15.5696593 3.87630586,14.9739621 3.12109375,14.21875 C2.36588164,13.4635379 1.7669293,12.5813853 1.32421875,11.5722656 C0.881508203,10.563146 0.66015625,9.48568281 0.66015625,8.33984375 C0.66015625,7.19400469 0.881508203,6.11328633 1.32421875,5.09765625 C1.7669293,4.08202617 2.36588164,3.19661836 3.12109375,2.44140625 C3.87630586,1.68619414 4.7584585,1.09049697 5.76757812,0.654296875 C6.77669775,0.218096777 7.85416094,0 9,0 Z M9.83984375,12.578125 L9.83984375,7.5 L8.16015625,7.5 L8.16015625,12.578125 L9.83984375,12.578125 Z M9.83984375,5.83984375 L9.83984375,4.16015625 L8.16015625,4.16015625 L8.16015625,5.83984375 L9.83984375,5.83984375 Z"
        id="info_full"
        fill="#009FD4"
      />
    </g>
  </svg>
);

export default InfoFullIcon;
